
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"51","height":"51","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.9 6.64c-1.778 0-3.197 1.424-3.197 3.155v.664H28.05l-2.234-2.672a3.213 3.213 0 00-2.465-1.146H10.9zm22.118 3.819c-.957 0-1.86-.422-2.465-1.147l-2.7-3.229a5.87 5.87 0 00-4.503-2.099H10.9c-3.221 0-5.853 2.59-5.853 5.81v20.52c0 3.221 2.632 5.811 5.852 5.811h6.898a1.328 1.328 0 100-2.656h-6.898c-1.777 0-3.196-1.424-3.196-3.155V13.115h32.398c1.78 0 3.2 1.428 3.196 3.16l-.036 14.046c-.004 1.728-1.422 3.148-3.196 3.148h-5.8a1.328 1.328 0 000 2.656h5.8c3.215 0 5.845-2.582 5.852-5.797l.036-14.045c.007-3.226-2.627-5.824-5.852-5.824h-7.083zm-6.19 12.916v15.938a1.328 1.328 0 11-2.656 0V23.374a1.328 1.328 0 112.656 0zm-7.58 19.002a1.328 1.328 0 111.879-1.879l3.622 3.623a1.063 1.063 0 001.502 0l3.622-3.623a1.328 1.328 0 111.879 1.879l-3.622 3.622a3.719 3.719 0 01-5.26 0l-3.622-3.622z","fill":"url(#paint0_linear_40003203_21095)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_40003203_21095","x1":"25.5","y1":"3.984","x2":"25.5","y2":"47.088","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#09A4FB"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#3840F3"}})])])])
          )
        }
      }
    